module.exports = __webpack_public_path__ + "svg/new-discover-big.4f410d07782386251aa57bf137b9b213.svg";